import React from 'react';
import classes from './publication.module.css';
import PublicationItem from './publicationitem';

const Publication = () => {

    const pub1 = "Yusuke Asai, Kei Hiroi, Takuro Yonezawa, Nobuo Kawaguchi: Optimization of Human Workload using Simulation of Warehouse Collaborative Robot In Multimedia, Distributed, Cooperative , and Mobile(DICOMO 2020) Symposium, 2020.6. (Japanese) "
    const pub2 = "Yusuke Asai, Kei Hiroi, Takuro Yonezawa, Nobuo Kawaguchi: Towards Adaptive Local Planning with Human Behavior Model for Mobile Robots In Multimedia, Distributed, Cooperative, and Mobile(DICOMO 2019) Symposium, 2019.7. (Japanese) "
    const pub3 = "浅井悠佑: 倉庫における人と自立配送ロボットの協調制御手法の基礎的検討, WIDE 研究会, 2019"

    return (
        <div className={classes.container}>
            <h3>Publication</h3>
            <PublicationItem pub={ pub1 } />
            <PublicationItem pub={ pub2 } />
            <h4>Poster Presentation</h4>
            <PublicationItem pub={pub3} />
        </div>
    );
}

export default Publication;